var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {TransferDeviceAsync as InvokeAsync , TransferDeviceSync as InvokeSync}

async function TransferDeviceAsync(LoginToken,DeviceUUID,NewOwnerEmail)
{
    var TransferDevicePromise = new Promise((resolve, reject) => {
        TransferDeviceSync(LoginToken,DeviceUUID,NewOwnerEmail,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await TransferDevicePromise;
}

function TransferDeviceSync(LoginToken,DeviceUUID,NewOwnerEmail,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/TransferDevice',                
        data  : {
            AppID        :KEYS.AWS_APPID,
            DeviceUUID   :DeviceUUID ,
            NewOwnerEmail:NewOwnerEmail,
            LoginToken   :LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
